import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import useTheme from '@kufox/mui/hooks/useTheme';
import { css } from '@kufox/mui/emotion';
import { namespace } from './model';

const { setInterval, clearInterval } = window;
let interval;

const useStyle = ({ color }) => {
  return {
    date: css`
      margin-right: 42px;
      color: ${color.text60};
      font-size: 12px;
      line-height: 20px;
    `,
  };
};

export default function ServerTime(props) {
  const { serverTime } = useSelector((state) => state[namespace]);
  const [countDown, setCountDown] = useState(0);
  const theme = useTheme();
  const styles = useStyle({ color: theme.colors });
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: `${namespace}/pullServerTime@polling` });

    return () => {
      dispatch({ type: `${namespace}/pullServerTime@polling:cancel` });
    };
  }, []);

  useEffect(() => {
    setCountDown(serverTime);
    interval = setInterval(() => {
      setCountDown((countDown) => countDown + 1000);
    }, 1000);

    return () => {
      if (interval) {
        clearInterval(interval);
        interval = null;
      }
    };
  }, [serverTime]);

  if (countDown < 1) {
    return null;
  }
  return (
    <div css={styles.date}>
      {moment(countDown)
        .utcOffset(8)
        .format('YYYY-MM-DD HH:mm:ss')}
      &nbsp;&nbsp;(UTC+8)
    </div>
  );
}
